import React, { Component, MouseEvent, ReactNode } from 'react';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from '../FormicaSearchSelectBox';
import { query } from '@trlogic/client-js';
import { OverlayPanel } from 'primereact/overlaypanel';
import Icon from '../../../icons/Icon';
import CustomFilterLiteralComponent from './CustomFilterLiteralComponent';
import CustomFilterCategoricalComponent from './CustomFilterCategoricalComponent';
import CustomFilterDateComponent from './CustomFilterDateComponent';
import {
  CustomFilterCategorical,
  CustomFilterDateSearch,
  CustomFilterField,
  CustomFilterFields,
  CustomFilterLiteralSearch,
} from '../../../domain/ui/FilterDomains';
import { RootState } from '../../../redux/store';
import { changePageFilter } from '../../../redux/actions/PageActions';
import { connect, ConnectedProps } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import FilterUtil from '../../../util/FilterUtil';
import ComponentName from '../../../constant/ComponentName';
import UserService from '../../../service/UserService';
import ServiceContainer from '../../../config/ServiceContainer';
import { ServiceNames } from '../../../constant/ServiceNames';
import { DefaultFilter, User, UserSystemAttributes } from '../../../domain/rbac/RbacDomains';
import DefaultFilterUtil from '../../../util/DefaultFilterUtil';
import { Tooltip } from 'primereact/tooltip';
import MessageUtil from '../../../util/MessageUtil';
import { customConfirm } from '../CustomPopupConfirm';
import { PageState } from '../../../redux/reducers/PageReducer';
import LanguageUtil from '../../../util/LanguageUtil';
import Filter = query.Filter;

class CustomFilter extends Component<Props, State> {
  public state: State = new State();

  private overlayPanel: OverlayPanel | null = null;
  private readonly userService: UserService = ServiceContainer.getInstance().get(ServiceNames.USER);

  public render(): ReactNode {
    const { selectedIcon } = this.state;
    const { disabled, defaultFilterDisabled, componentId, componentName } = this.props;
    const filter = this.getFilter();
    const isAllEnabled = filter.filter.fields.every((f: CustomFilterField) => f.enabled);
    return (
      <div className='flex items-center justify-start gap-x-3'>
        <div className={'flex min-w-[150px] max-w-[150px] pl-0.5'}>
          <FormicaSearchSelectBox
            rounded={true}
            onChange={this.onChangeFilterType}
            value={filter.filter.type}
            customSize='medium'
            placeholder={LanguageUtil.get({ id: 'common.input.placeholder.filterType', defaultMessage: 'Filter Type' })}
            options={this.getOptions()}
            disabled={disabled}
            icon={selectedIcon}
          />
        </div>
        <Tooltip target='.default-filter'>
          {LanguageUtil.get({ id: 'common.label.setAsDefaultConfiguration', defaultMessage: 'Set as default configuration' })}
        </Tooltip>
        <Tooltip target='.toggle-filter'>
          {isAllEnabled
            ? LanguageUtil.get({
                id: 'common.label.disableAllFilters',
                defaultMessage: 'Disable All Filters',
              })
            : LanguageUtil.get({ id: 'common.label.enableAllFilters', defaultMessage: 'Enable All Filters' })}
        </Tooltip>
        <div className='flex gap-[6px]'>
          {defaultFilterDisabled || (componentName == ComponentName.CASE && componentId == undefined) || (componentName == ComponentName.ASSESSMENT && componentId == undefined) || !componentName ? null : (
            <div
              onClick={this.onChangeDefaultFilter}
              className='cursor-pointer border rounded border-[#E0E4E8] w-[34px] h-[34px] flex items-center justify-center bg-white-1 hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7]'
            >
              <Icon className={'default-filter text-f-black-3 '} size={16} icon={'bookmark_added'} />
            </div>
          )}
          <div
            onClick={this.toggleFilters}
            className='cursor-pointer border rounded border-[#E0E4E8] w-[34px] h-[34px] flex items-center justify-center bg-white-1 hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7]'
          >
            <Icon className={'toggle-filter text-f-black-3 '} size={16} icon={isAllEnabled ? 'visibility_off' : 'visibility'} />
          </div>
          {
            <div
              onClick={(e) => this.clearAllFilters(e)}
              className='cursor-pointer border rounded border-[#E0E4E8] w-[34px] h-[34px] flex items-center justify-center bg-white-1 hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7]'
            >
              <Icon id={'delete-all-filters'} className={'text-f-black-3 '} icon={'delete'} size={18} />
              <Tooltip target={'#delete-all-filters'}>
                {LanguageUtil.get({ id: 'common.label.deleteAllFilters', defaultMessage: 'Delete All Filters' })}
              </Tooltip>
            </div>
          }
        </div>
        {(filter.filter.fields as CustomFilterField[])?.length == 0 ? null : (
          <div className='custom-scroll flex gap-x-2 overflow-x-scroll'>{this.getFilterFields()}</div>
        )}
        <div className={'w-[1px] h-7 box-border bg-[#E0E4E8]'}></div>
        <div
          id='filter-fields'
          className={`text-[#458EF7] select-none  flex shrink-0 items-center ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
          onClick={this.onClickAddFilter}
        >
          {LanguageUtil.get({ id: 'common.label.addFilter', defaultMessage: 'Add Filter' })}
          <Icon icon='addition' size={24} color='#458EF7' className={`fill-[#458EF7] ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`} />
        </div>
        <OverlayPanel ref={(r) => (this.overlayPanel = r)} onHide={this.onHideOverlayPanel}>
          <div className='flex flex-col overflow-scroll w-[250px] max-h-[300px] relative'>
            <div className={'flex w-full h-full py-2 px-2 border-b-[1px] sticky top-0 bg-main-gray border-[#E0E4E8]'}>
              <input
                className={'flex w-full h-[32px] border-[1px] border-[#E0E4E8] outline-none text-md indent-2 rounded-[4px]'}
                placeholder={LanguageUtil.get({ id: 'common.input.placeholder.search', defaultMessage: 'Search' })}
                value={this.state.search}
                onChange={(e) => {
                  this.setState({ search: e.currentTarget.value });
                }}
              />
            </div>
            {filter.items
              .filter((item: CustomFilterFields) => item.label?.toLowerCase().includes(this.state.search?.toLowerCase() || ''))
              .map((item: CustomFilterFields) => (
                <span
                  key={item.key + item.label}
                  onClick={() => this.addFilter(item)}
                  className={`hover:bg-[#F9FAFB] text-md h-10 text-[#4F4F4F] px-2 py-3 text-start ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                >
                  {item.label}
                </span>
              ))}
          </div>
        </OverlayPanel>
      </div>
    );
  }

  public componentDidUpdate(prevProps: Readonly<Props>) {
    const { onChange } = this.props;
    if (!_.isEqual(this.getFilter(prevProps), this.getFilter(this.props))) {
      onChange(this.parseFilter());
    }
  }

  private onChangeDefaultFilter = () => {
    const {
      user: { user, attributes },
      componentId,
      componentName,
      changePageFilter,
    } = this.props;
    delete user.lastLoginDate;
    const _user: User = {
      ...user,
      filters: attributes.filters || [],
    };
    const filter = this.getFilter();
    const riskType = user.activeRiskType;
    let existingFilter: DefaultFilter | undefined;
    switch (componentName) {
      case ComponentName.CASE:
        existingFilter = _user.filters?.find(
          (f: DefaultFilter) => f.id == componentId && f.riskType === riskType,
        );
        break;
      case ComponentName.ENTITY:
      case ComponentName.ASSESSMENT:
      case ComponentName.WATCHLIST_ALERT:
        existingFilter = DefaultFilterUtil.find(_user.filters, {
          component: componentName,
          id: componentId,
          riskType,
        });
        break;
      default:
        existingFilter = DefaultFilterUtil.find(_user.filters, {
          component: componentName!,
          id: undefined,
          riskType,
        });
        break;
    }
    if (existingFilter != undefined) {
      existingFilter.filter = filter;
    } else {
      _user.filters?.push({
        component: componentName!,
        id: componentId,
        riskType,
        filter: filter,
      });
    }
    if ((attributes as UserSystemAttributes).tabOrders == null || !Array.isArray((attributes as UserSystemAttributes).tabOrders)) {
      (attributes as UserSystemAttributes).tabOrders = [];
    }
    (attributes as UserSystemAttributes).username = user.username;
    (attributes as UserSystemAttributes).id = user.username;
    this.userService
      .saveAttributes(attributes)
      .then(() => {
        MessageUtil.success({
          summary: LanguageUtil.get({ id: 'common.label.filter', defaultMessage: 'Filter' }),
          detail: <div>{LanguageUtil.get({ id: 'messages.success.filterSaved', defaultMessage: 'Filter Saved' })}</div>,
        });
      })
      .catch((e) => {
        console.error(e);
        MessageUtil.error({
          summary: LanguageUtil.get({ id: 'common.label.filter', defaultMessage: 'Filter' }),
          detail: <div>{LanguageUtil.get({ id: 'messages.error.filterCouldNotBeSaved', defaultMessage: 'Filter could not be saved' })}</div>,
        });
      });
    changePageFilter(this.getFilter());
  };

  private onChangeFilterType = (value: FormicaSelectBoxItem | undefined) => {
    const { changePageFilter, onChange, disabled } = this.props;
    if (disabled) return;
    if (value == undefined) return;
    const filter = this.getFilter();
    filter.filter.type = value.value;
    changePageFilter(this.getFilter() as any);
    onChange(this.parseFilter());
    this.setState({ selectedIcon: value.icon });
  };

  private getFilterFields = () => {
    const { onChange } = this.props;
    const filter = this.getFilter();
    return (filter.filter.fields as CustomFilterField[])?.map((f, i) => {
      switch (f.search.type) {
        case 'LITERAL':
          return (
            <div className='w-full flex justify-start items-center min-w-fit'>
              <CustomFilterLiteralComponent
                field={f}
                key={i + f.field + f.search.type}
                id={i + f.field + f.search.type}
                onChange={this.onChangeFilter}
                onApply={() => onChange(this.parseFilter())}
                onRemove={() => this.remove(f)}
                onToggle={() => this.toggle(f)}
              />
            </div>
          );
        case 'CATEGORICAL':
          return (
            <div className='w-full flex justify-start items-center min-w-fit'>
              <CustomFilterCategoricalComponent
                field={f}
                key={i + f.field + f.search.type}
                id={i + f.field + f.search.type}
                fields={filter.items}
                onChange={this.onChangeFilter}
                onApply={() => onChange(this.parseFilter())}
                onRemove={() => this.remove(f)}
                onToggle={() => this.toggle(f)}
              />
            </div>
          );
        case 'DATE':
          return (
            <div className='w-full flex justify-start items-center min-w-fit'>
              <CustomFilterDateComponent
                field={f}
                key={i + f.field + f.search.type}
                id={i + f.field + f.search.type}
                onChange={this.onChangeFilter}
                onApply={() => onChange(this.parseFilter())}
                onRemove={() => this.remove(f)}
                onToggle={() => this.toggle(f)}
              />
            </div>
          );
      }
    });
  };

  private addFilter = (f: CustomFilterFields): void => {
    if (this.props.disabled) return;
    const { changePageFilter } = this.props;
    let value: CustomFilterLiteralSearch | CustomFilterCategorical | CustomFilterDateSearch;
    const filter = this.getFilter();
    if (f.type == 'LITERAL') {
      value = {
        properties: { dataType: f.properties.dataType },
        operator: 'eq',
        value: '',
      };
    } else if (f.type == 'CATEGORICAL') {
      value = {
        values: [],
      } as CustomFilterCategorical;
    } else {
      value = {
        startDate: {
          label: LanguageUtil.get({ id: 'common.label.1hourAgo', defaultMessage: '1 Hour ago' }),
          value: moment().subtract('1', 'hour').toDate(),
          type: 'Relative',
        },
        endDate: {
          label: LanguageUtil.get({ id: 'common.label.now', defaultMessage: 'Now' }),
          value: 0,
          type: 'Now',
        },
      } as CustomFilterDateSearch;
    }
    const newFilter: CustomFilterField = {
      field: f.key,
      label: f.label,
      search: {
        type: f.type,
        subType: f.subType,
        value: value,
      },
      enabled: true,
      emptyMeansNone: f.emptyMeansNone,
    };
    const index = filter.filter.fields.push(newFilter);
    changePageFilter(this.getFilter());
    this.overlayPanel?.hide();
    const id = `filter-toggle-${index - 1}${newFilter.field}${newFilter.search.type}`;
    setTimeout(() => {
      const el = document.getElementById(id);
      el?.click();
    }, 10);
  };

  private parseFilter = () => {
    const filter = this.getFilter();
    return FilterUtil.parse(filter.filter);
  };

  private getOptions() {
    return [
      {
        label: LanguageUtil.get({ id: 'common.label.anyMatch', defaultMessage: 'Any Match' }),
        value: 'ANY_MATCH',
        icon: 'anymatch',
      },
      {
        label: LanguageUtil.get({ id: 'common.label.allMatch', defaultMessage: 'All Match' }),
        value: 'ALL_MATCH',
        icon: 'allmatch',
      },
      {
        label: LanguageUtil.get({ id: 'common.label.noneMatch', defaultMessage: 'None Match' }),
        value: 'NONE_MATCH',
        icon: 'nonematch',
      },
    ];
  }

  private onClickAddFilter = (event: MouseEvent) => {
    if (this.props.disabled) return;
    this.overlayPanel?.toggle(event, event.currentTarget);
  };

  private onChangeFilter = () => {
    if (this.props.disabled) return;
    const { changePageFilter } = this.props;
    changePageFilter(this.getFilter());
  };

  private remove = (f: CustomFilterField) => {
    if (this.props.disabled) return;
    const { changePageFilter, onChange } = this.props;
    const filter = this.getFilter();
    const index = filter.filter.fields.indexOf(f);
    if (index != -1) {
      filter.filter.fields.splice(index, 1);
      changePageFilter(filter);
      onChange(this.parseFilter());
    }
  };

  private clearAllFilters = (event: React.MouseEvent<HTMLDivElement>) => {
    if (this.props.disabled) return;
    customConfirm({
      message: LanguageUtil.get({ id: 'messages.confirm.clearFilters', defaultMessage: 'Are you sure you want to clear all filters?' }),
      target: event.currentTarget,
      accept: () => {
        const { changePageFilter, onChange } = this.props;
        const filter = this.getFilter();
        filter.filter.fields = [];
        changePageFilter(filter);
        onChange(this.parseFilter());
      },
    });
  };

  private toggle = (f: CustomFilterField) => {
    if (this.props.disabled) return;
    const { changePageFilter, onChange } = this.props;
    const filter = this.getFilter();
    f.enabled = !f.enabled;
    changePageFilter(filter);
    onChange(this.parseFilter());
  };

  private toggleFilters = () => {
    const { changePageFilter, onChange } = this.props;
    const { filter } = this.getFilter();
    if (this.props.disabled) return;
    const isAllEnabled = filter.fields.every((f: CustomFilterField) => f.enabled);
    filter.fields.forEach((f: CustomFilterField) => (f.enabled = !isAllEnabled));
    changePageFilter(this.getFilter());
    onChange(this.parseFilter());
  };

  private onHideOverlayPanel = () => {
    const selection = window.getSelection();
    if (selection && selection.toString().length > 0) {
      return;
    }

    this.setState({ search: undefined });
  };

  private getFilter(props?: Props | Readonly<Props>) {
    const { filterKey, page } = props ?? this.props;
    if (!filterKey) return page.filter;
    return page.filters[filterKey] ?? page.filter;
  }
}

export interface Props extends ReduxProps {
  onChange: (filter: Filter) => void;
  disabled?: boolean;
  componentName?: ComponentName;
  componentId?: string;
  defaultFilterDisabled?: boolean;
  filterKey?: string;
}

class State {
  search: string | undefined = undefined;
  selectedIcon: string | undefined = 'anymatch';
}

const mapStateToProps = (state: RootState) => ({
  page: state.page as PageState,
  user: state.auth,
});
const mapDispatchToProps = { changePageFilter };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(CustomFilter);
